


















import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { DispensationPayload } from '@/api/dispensation/types'
import BaseTab from './baseTab'

@Component({
  components: {
    DispensationCreateForm: () =>
      import('@/components/dispensationCreateTab/DispensationCreateForm.vue'),
    DispensationCreateFormConfirm: () =>
      import(
        '@/components/dispensationCreateTab/DispensationCreateFormConfirm.vue'
      )
  }
})
export default class DispensationCreateTab extends mixins(BaseTab) {
  @Prop(Number) patientId!: number

  confirmMode = false
  payload: DispensationPayload | null = null

  handleConfirm(payload: DispensationPayload) {
    this.payload = payload
    this.confirmMode = true
  }

  handleEdit() {
    this.confirmMode = false
  }

  handleSubmit() {
    this.confirmMode = false
    this.payload = null
  }
}
